import { TabPanelUI } from './base/ui/tabPanelUI';
import { BaseUITools } from './base/baseUITools';
import { createTabPanelTool, TabPanelToolItem, TabPanelToolUI } from './base/ui/tabPanelToolUI';
import { ScenePanelTools } from './panelControls/scene-panel-tools';
import { CameraPanelTools } from './panelControls/camera-panel-tools';
import { ModelPanelTools } from './panelControls/model-panel-tools';
import { LightPanelTools } from './panelControls/light-panel-tools';
import { HeatmapPanelTools } from './panelControls/heatmap-panel-tools';
import { globalManager, globalTools } from '@/utils/globalConfig';
import { RightPanelTabs } from '@/utils/commonParams';


export class RightPanelTools extends BaseUITools {
    private tabPanelUI: TabPanelUI | null = null;
    private tabPanelToolUI: TabPanelToolUI | null = null;
    private scenePanelTools: ScenePanelTools | null = null;
    private modelPanelTools: ModelPanelTools | null = null;
    private cameraPanelTools: CameraPanelTools | null = null;
    private lightPanelTools: LightPanelTools | null = null;
    public heatmapPanelTools: HeatmapPanelTools | null = null;

    constructor(id: string) {
        super(id, false);
        this.init_tabPanelToolUI();
    }

    init_tabPanelToolUI() {
        // 创建Tab项
        const items = [
            new TabPanelToolItem(RightPanelTabs.scene),
            new TabPanelToolItem(RightPanelTabs.model),
            new TabPanelToolItem(RightPanelTabs.camera),
            new TabPanelToolItem(RightPanelTabs.heatmap),
            // new TabPanelToolItem(RightPanelTabs.light),
        ];

        this.tabPanelToolUI = createTabPanelTool({
            id: 'tab-panel-tool-ui',
            items: items,
            tabPosition: 'left',
            showBorder: false,
            allowClose: false,
            onTabChange: (item, index) => {
                console.log('切换到Tab:', item.title);
                handleTabChange(index, item);
            }
        });

        function handleTabChange(index: number, item: TabPanelToolItem) {
            console.log("*******************", index, item)
            globalManager.setActivePanelTab(item.id);
            globalManager.openRightToolsBar();
        }
        // 控制Tab
        this.tabPanelToolUI.setActiveTab(globalManager.getActivePanelTab());

        this.appendChild('tabPanelToolUI', this.tabPanelToolUI.getContainer());

        const scenePanelTools = new ScenePanelTools('scene-panel-tools-panel');
        this.scenePanelTools = scenePanelTools;
        this.tabPanelToolUI.setTabContent('scene', scenePanelTools.getContainer() as HTMLElement);

        // 连接网格开关到双视窗场景
        setTimeout(() => {
            this.connectGridControlToScenes(scenePanelTools);
        }, 1000); // 延迟确保场景已初始化

        const modelPanelTools = new ModelPanelTools('model-panel-tools-panel');
        this.modelPanelTools = modelPanelTools;
        this.tabPanelToolUI.setTabContent('model', modelPanelTools.getContainer() as HTMLElement);

        const cameraPanelTools = new CameraPanelTools('camera-tools-panel');
        this.cameraPanelTools = cameraPanelTools;
        this.tabPanelToolUI.setTabContent('camera', cameraPanelTools.getContainer() as HTMLElement);

        const lightPanelTools = new LightPanelTools('light-panel-tools-panel');
        this.lightPanelTools = lightPanelTools;
        this.tabPanelToolUI.setTabContent('light', lightPanelTools.getContainer() as HTMLElement);

        const heatmapPanelTools = new HeatmapPanelTools('heatmap-panel-tools-panel');
        this.heatmapPanelTools = heatmapPanelTools;
        this.tabPanelToolUI.setTabContent('heatmap', heatmapPanelTools.getContainer() as HTMLElement);

        // 连接相机面板到左侧相机控制器
        setTimeout(() => {
            this.connectCameraPanelToController(cameraPanelTools);
        }, 1000); // 延迟确保场景已初始化
    }

    checkViewPanelHasHeatmap(sceneId: string): boolean {
        if (this.heatmapPanelTools) {
            return this.heatmapPanelTools.checkViewPanelHasHeatmap(sceneId);
        }
        return false;
    }
    setActiveTab(tabId: string) {
        if (this.tabPanelToolUI) {
            this.tabPanelToolUI.setActiveTab(tabId);
        }
    }
    destroy() {
        if (this.tabPanelUI) {
            this.tabPanelUI.destroy();
        }
        if (this.tabPanelToolUI) {
            this.tabPanelToolUI.destroy();
        }
    }
    getTabPanelUI(): TabPanelUI | null {
        return this.tabPanelUI;
    }
    getTabPanelToolUI(): TabPanelToolUI | null {
        return this.tabPanelToolUI;
    }

    onResetAll() {
        if (this.scenePanelTools) {
            this.scenePanelTools.onReset();
        }
        if (this.modelPanelTools) {
            this.modelPanelTools.onReset();
        }
        if (this.cameraPanelTools) {
            this.cameraPanelTools.onReset();
        }
    }

    onUpdateCamera(cameraParams: any) {
        if (this.cameraPanelTools) {
            this.cameraPanelTools.onUpdateCamera(cameraParams);
        }
    }
    /**
     * 连接网格开关到双视窗场景
     */
    private connectGridControlToScenes(scenePanelTools: ScenePanelTools): void {
        try {
            if (!globalTools?.mainViewTools) {
                console.warn('MainViewTools not available, retrying...');
                setTimeout(() => this.connectGridControlToScenes(scenePanelTools), 500);
                return;
            }

            // 获取左右场景视图工具
            const leftSceneViewTools = globalTools.mainViewTools.getLeftSceneViewTools();
            const rightSceneViewTools = globalTools.mainViewTools.getRightSceneViewTools();

            if (!leftSceneViewTools || !rightSceneViewTools) {
                // console.warn('SceneViewTools not available, retrying...');
                setTimeout(() => this.connectGridControlToScenes(scenePanelTools), 500);
                return;
            }

            // 获取场景实例
            const leftScene = leftSceneViewTools.getScene();
            const rightScene = rightSceneViewTools.getScene();

            if (!leftScene || !rightScene) {
                console.warn('Scenes not available, retrying...');
                setTimeout(() => this.connectGridControlToScenes(scenePanelTools), 500);
                return;
            }

            // 获取网格开关并设置初始状态（默认开启）
            const gridControl = scenePanelTools.getGridControl();
            if (gridControl) {
                // 设置初始状态为开启（网格默认显示）
                gridControl.setChecked(true);

                // 连接开关变化事件到场景网格显示/隐藏
                gridControl.onChange((checked: boolean) => {
                    leftScene.setGridVisible(checked);
                    rightScene.setGridVisible(checked);
                    console.log('网格显示状态:', checked ? '显示' : '隐藏');
                });
            }

            console.log('网格开关已成功连接到双视窗场景');
        } catch (error) {
            console.error('连接网格开关到场景失败:', error);
        }
    }

    /**
     * 连接相机面板到左侧相机控制器
     */
    private connectCameraPanelToController(cameraPanelTools: CameraPanelTools): void {
        try {
            // 通过全局工具访问 MainViewTools
            if (!globalTools?.mainViewTools) {
                console.warn('MainViewTools not available, retrying...');
                setTimeout(() => this.connectCameraPanelToController(cameraPanelTools), 500);
                return;
            }

            // 获取左侧场景视图工具
            const leftSceneViewTools = globalTools.mainViewTools.getLeftSceneViewTools();
            if (!leftSceneViewTools) {
                console.warn('LeftSceneViewTools not available, retrying...');
                setTimeout(() => this.connectCameraPanelToController(cameraPanelTools), 500);
                return;
            }

            // 获取左侧相机控制器
            const leftCameraController = leftSceneViewTools.getCameraController();
            if (!leftCameraController) {
                console.warn('LeftCameraController not available, retrying...');
                setTimeout(() => this.connectCameraPanelToController(cameraPanelTools), 500);
                return;
            }

            // 连接相机面板到相机控制器
            cameraPanelTools.setCameraController(leftCameraController);

            // 设置相机面板更新回调
            leftCameraController.setCameraPanelUpdateCallback(() => {
                cameraPanelTools.updateUIFromCamera();
            });

            console.log('相机面板已成功连接到左侧相机控制器');
        } catch (error) {
            console.error('连接相机面板到相机控制器失败:', error);
        }
    }
    setSkyboxEnabled(enabled: boolean) {
        if (this.scenePanelTools) {
            this.scenePanelTools.setSkyboxEnabled(enabled);
        }
    }
}
